import React from 'react';
import Modal from '../Modal';
import { asyncState } from '~/hooks';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const LoadingSpinner = ({ status }) => {
    const open = status == asyncState.PENDING;

    return (
        <Modal isModalOpen={open} className='bg-transparent border-none flex items-center justify-center focus:outline-none'>
            <AiOutlineLoading3Quarters className='text-blue-30 animate-spin' size='4rem' />
        </Modal>
    );
};

export default LoadingSpinner;